import { useHistory } from 'react-router-dom';
import { t } from 'i18next';

import Button from 'components/Button/Button';

import QuizSubTitle from '../QuizSubHeader/QuizSubHeader';

import './QuizStarter.scoped.scss';

const QuizStarter = () => {
  const history = useHistory();
  return (
    <div className="quizstarter-container">
      <QuizSubTitle title={t('study:pre_exam')} />
      <div className="description">
        <p>{t('study:quiz_text')}</p>
      </div>
      <Button
        onClick={() => history.push('/quiz/questions')}
        round
        style={{
          backgroundColor: '#5CD79E',
          border: '2px solid #5CD79E',
          width: '130px',
          color: '#fff',
          margin: '0px 30px',
          fontSize: '15px',
          fontWeight: 600,
        }}
      >
        {t('study:start_quiz')}
      </Button>
    </div>
  );
};

export default QuizStarter;
